<template>
  <!-- 日报——我发起的 -->
  <div class="issued">
    <!-- 筛选 -->
    <div class="screen">
      <span>项目：</span>
      <el-select v-model="screen.prjId" size="small" clearable placeholder="全部">
        <el-option v-for="item in dailyProjects" :key="item.prjId" :label="item.prjName" :value="item.prjId">
        </el-option>
      </el-select>

      <span>内容：</span>
      <el-input v-model="screen.content" size="small" suffix-icon="el-icon-search" placeholder="请输入关键字">
      </el-input>

      <span>状态：</span>
      <el-select v-model="screen.state" size="small" clearable placeholder="请选择">
        <el-option v-for="item in states" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>

      <span>日期：</span>
      <el-date-picker v-model="screen.date" size="small" range-separator="至" start-placeholder="开始时间"
        end-placeholder="结束时间" type="daterange">
      </el-date-picker>
      <el-button size="small" type="primary" style="margin-left: 20px" @click="getDailyData">查询</el-button>
      <el-button size="small" @click="reset">重置</el-button>
    </div>

    <!-- 日报数据 -->
    <div class="dailyData">
      <!-- 操作行 -->
      <div class="operationRow">
        <el-button size="small" type="primary" icon="el-icon-plus" @click="dialogAddOpen">新增</el-button>
      </div>
      <!-- 日报表 -->
      <el-table ref="dailyTable" height="100%" highlight-current-row :data="dailyData"
        tooltip-effect="dark" :row-class-name="tableRowClassName" border>
        <el-table-column label="序号" align="center" width="80" type="index">
        </el-table-column>
        <el-table-column label="项目名称" align="center" width="180" prop="prjName" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="日期" align="center" width="180" prop="reportDate">
        </el-table-column>
        <el-table-column label="内容" align="center" min-width="300">
          <template #default="{ row }">
            <el-link type="primary" @click="dialogSeeOpen(row)">
              <span class="contentText" :title="row.designManageContent">{{ row.designManageContent }}</span>
            </el-link>
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center" width="120">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status == 0" size="small" type="success">已提交</el-tag>
            <el-tag v-if="scope.row.status == 1" size="small" type="danger">已撤回</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="提交时间" align="center" width="300" prop="createTime">
        </el-table-column>
        <el-table-column label="操作" align="center" width="250">
          <template slot-scope="scope">
            <el-link v-if="scope.row.status == 0" type="primary" @click="withdraw(scope.row)">撤回</el-link>
            <el-link v-if="scope.row.status == 1" type="primary" @click="dialogEditOpen(scope.row)">编辑</el-link>
            <el-link v-if="scope.row.status == 1" type="primary" @click="deleteDaily(scope.row)">删除</el-link>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination background layout="total, prev, pager, next" :total="totalCount" :page-count="totalPage"
        :current-page.sync="currentPage">
      </el-pagination>
    </div>

    <!-- 新增弹框 -->
    <dailyAdd ref="dailyAdd" @refreshList="getDailyData"></dailyAdd>
    <!-- 查看弹框 -->
    <dailySee ref="dailySee" :report-id="currentRow.reportId" @refreshList="getDailyData"></dailySee>
    <!-- 编辑弹框 -->
    <dailyEdit ref="dailyEdit" :report-id="currentRow.reportId" @refreshList="getDailyData"></dailyEdit>
  </div>
</template>

<script>
import dailyAdd from "./dailyAdd.vue";
import dailySee from "./dailySee.vue";
import dailyEdit from "./dailyEdit.vue";
import dailyService from "@/CommonDP/service/daily-service";
import { mapState } from "vuex";
import moment from "moment";

export default {
  components: { dailyAdd, dailySee, dailyEdit },
  data() {
    return {
      states: [
        { label: "已提交", value: 0 },
        { label: "已撤回", value: 1 }
      ], // 状态
      dailyProjects: [], // 筛选项目

      screen: {
        prjId: "", // 筛选--项目
        content: "", // 筛选--内容
        state: "", // 筛选--状态（是否已读）
        date: [], // 筛选--日期
        pageSize: 20,
        pageNum: 1
      },
      dailyData: [], // 列表数据
      totalCount: 1, // 总数
      totalPage: 1, // 分页总数
      currentPage: 1, // 当前页
      currentRow: {} // 当前行
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),

    // 开始时间
    startDate() {
      if (this.screen.date && this.screen.date.length > 0) {
        return moment(this.screen.date[0]).format("YYYY-MM-DD") + " 00:00:00";
      } else {
        return "";
      }
    },
    // 结束时间
    endDate() {
      if (this.screen.date && this.screen.date.length > 1) {
        return moment(this.screen.date[1]).format("YYYY-MM-DD") + " 23:59:59";
      } else {
        return "";
      }
    }
  },
  watch: {
    currentPage(val) {
      this.screen.pageNum = val;
      this.getDailyData();
    }
  },
  mounted() {
    this.getDailyData();
  },
  methods: {
    // 把每一行的索引放进row
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex;
    },

    // 获得筛选项目 type: 1我发出的 2我收到的
    async getDailyProjects() {
      const params = {
        enterpriseId: this.enterpriseId,
        type: "1"
      };
      const res = await dailyService.getPrjList(params);
      this.dailyProjects = res.data;
    },

    // 获得列表数据
    async getDailyData() {
      const params = {
        enterpriseId: this.enterpriseId,
        type: "1", // 我发出的
        prjId: this.screen.prjId, // 项目id
        keyword: this.screen.content, // 关键字
        status: this.screen.state, // 状态
        startDate: this.startDate, // 开始时间
        endDate: this.endDate, // 结束时间
        pageSize: this.screen.pageSize,
        pageNum: this.screen.pageNum
      };
      const res = await dailyService.getList(params);
      this.totalPage = res.totalPage;
      this.totalCount = res.totalCount;
      this.dailyData = res.data;
      this.getDailyProjects();
    },

    // 重置
    reset() {
      this.screen = {
        prjId: "", // 筛选--项目
        content: "", // 筛选--内容
        state: "", // 筛选--状态（是否已读）
        date: [], // 筛选--日期
        pageSize: 20,
        pageNum: 1
      };
      this.getDailyData();
    },

    // 撤回提示
    withdraw(row) {
      this.$confirm("确定要撤回此条日报吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        await dailyService.recall(row.reportId);
        this.$message({
          type: "success",
          message: "撤回成功!"
        });
        this.getDailyData();
      });
    },

    // 删除提示
    deleteDaily(row) {
      this.$confirm("确定要删除此条日报吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        await dailyService.delete(row.reportId);
        this.$message({
          type: "success",
          message: "删除成功!"
        });
        this.getDailyData();
      });
    },

    // 打开新增弹框
    dialogAddOpen() {
      this.$refs.dailyAdd.dialogAddShow = true;
    },
    // 打开查看弹框
    dialogSeeOpen(row) {
      this.currentRow = row;
      this.$refs.dailySee.dialogSeeShow = true;
    },
    // 打开编辑弹框
    dialogEditOpen(row) {
      this.currentRow = row;
      this.$refs.dailyEdit.dialogEditShow = true;
    }
  }
};
</script>

<style lang='scss' scoped>
.issued {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .screen {
    width: 100%;
    padding: var(--middle-space) var(--big-space);
    border-bottom: 1px solid #e5e8f1;
    display: flex;
    align-items: center;

    span {
      margin-left: var(--middle-space);
      font-family: "PingFang SC";
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;
      color: var(--common-color);
      white-space: nowrap;
    }

    .el-input {
      width: 234px;
    }

    .el-button {
      padding: 9px 17px;
    }
  }

  .dailyData {
    width: 100%;
    height: 1px;
    flex-grow: 1;
    padding: 0 var(--big-space);
    display: flex;
    flex-direction: column;

    .operationRow {
      width: 100%;
      padding: var(--middle-space) 0;
    }

    .el-table {
      flex-grow: 1;
      .contentText {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }

      .el-link {
        margin: 0 var(--small-space);
      }
    }

    .el-pagination {
      margin-left: auto;
      padding: var(--middle-space) 0;
    }
  }
}

/deep/ .el-range-separator {
  width: max-content;
}
</style>
